import { useState, useEffect } from 'react';
import { getStorageUrl } from '../lib/firebase';

export function useStorageUrl(path: string | null | undefined) {
  const [url, setUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    let active = true;

    async function loadUrl() {
      if (!path) {
        setUrl(null);
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        const downloadUrl = await getStorageUrl(path);
        if (!active) return;
        setUrl(downloadUrl);
        setError(null);
      } catch (err) {
        if (!active) return;
        console.error('Error loading storage URL:', err);
        setError(err as Error);
        setUrl(null);
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    }

    loadUrl();

    return () => {
      active = false;
    };
  }, [path]);

  return { url, loading, error };
}
